import { motion } from "framer-motion";

const ease = [0.2, 0.7, 0.2, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 1, delay, ease }}
      {...rest}
    >
      {children}
    </M>
  );
};

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0.2, inView = false }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" })}
  >
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${lineClassName}`}
          variants={{ hidden: { y: "105%" }, show: { y: 0 } }}
          transition={{ duration: 1.2, delay: delay + i * 0.14, ease: [0.7, 0, 0.2, 1] }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const GoldRule = ({ className = "" }) => (
  <motion.span
    className={`block h-px origin-left bg-gold ${className}`}
    initial={{ scaleX: 0 }}
    whileInView={{ scaleX: 1 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 1.4, ease }}
  />
);
